import { useEffect } from "react";
import { useNavigate } from "react-router";
const basePath = process.env.REACT_APP_BASE_URL;

export const NotFound = () => {
  const navigate = useNavigate();

  useEffect(() => {
    return navigate(`${basePath}`);
  }, [navigate]);

  return <h1>Page Not Found</h1>;
};
